"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var colors_1 = require("../util/colors");
var grid_1 = require("./grid");
var IconButton_1 = __importDefault(require("./IconButton"));
var typography_1 = require("./typography");
var Close_1 = __importDefault(require("../icons/Close"));
var PromoBanner = function (_a) {
    var _b = _a.backgroundColor, backgroundColor = _b === void 0 ? colors_1.colors.purple500 : _b, children = _a.children;
    var _c = (0, react_1.useState)(false), hidden = _c[0], setHidden = _c[1];
    if (!children || hidden)
        return null;
    return (react_1.default.createElement(grid_1.Container, { center: true, py: 1, px: 3, style: { backgroundColor: backgroundColor, width: '100%' }, wrap: false },
        react_1.default.createElement(typography_1.P, { pr: 3, color: colors_1.colors.white, weight: 500 }, children),
        react_1.default.createElement(IconButton_1.default, { onClick: function () { return setHidden(true); }, bgColor: "transparent" },
            react_1.default.createElement(Close_1.default, { color: colors_1.colors.white }))));
};
exports.default = PromoBanner;
//# sourceMappingURL=PromoBanner.js.map